import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { TextField } from '@mui/material'
import PropTypes from 'prop-types'

const FormInputText = ({
    className = '',
    color = 'primary',
    control,
    disabled = false,
    inputProps = {},
    inputType = 'text',
    label = '',
    name,
    onHandleBlur = null,
    onHandleChange = null,
    placeholder = '',
    rules = {},
    shouldUnregister = false,
    size = 'medium',
    sx = {},
    variant = 'outlined',
}) => {
    const { t } = useTranslation()

    return (
        <Controller
            control={control}
            disabled={disabled}
            key={name}
            name={name}
            render={({ field: { onBlur, onChange, ref, value }, fieldState }) => (
                <TextField
                    className={className}
                    color={color}
                    disabled={disabled}
                    error={!!fieldState.error}
                    helperText={t(fieldState.error?.message)}
                    inputRef={ref}
                    label={label}
                    placeholder={placeholder}
                    size={size}
                    slotProps={{
                        input: {
                            disableUnderline: disabled,
                        },
                        htmlInput: inputProps,
                        inputLabel: {
                            shrink: true,
                        },
                    }}
                    sx={[sx, ...(Array.isArray(sx) ? sx : [sx])]}
                    type={inputType}
                    value={value || ''}
                    variant={variant}
                    fullWidth
                    onBlur={(e) => {
                        onBlur(e)
                        if (onHandleBlur) {
                            onHandleBlur(e)
                        }
                    }}
                    onChange={(e) => {
                        onChange(e)
                        if (onHandleChange) {
                            onHandleChange(e)
                        }
                    }}
                />
            )}
            rules={rules}
            shouldUnregister={shouldUnregister}
        />
    )
}

FormInputText.propTypes = {
    control: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    inputProps: PropTypes.object,
    inputType: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    rules: PropTypes.object,
    shouldUnregister: PropTypes.bool,
    size: PropTypes.string,
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
        PropTypes.func,
        PropTypes.object,
    ]),
    variant: PropTypes.string,
    onHandleBlur: PropTypes.func,
    onHandleChange: PropTypes.func,
}

export default FormInputText
